export const OUTREACH_TAB_VALUES = [
    'health',
    'generation_comparison',
    'agent',
    'auto_draft',
    'tv',
] as const;

export type OutreachTab = (typeof OUTREACH_TAB_VALUES)[number];

export const OUTREACH_TAB_LABELS: Record<OutreachTab, string> = {
    health: 'Health',
    generation_comparison: 'Port',
    agent: 'Agent',
    auto_draft: 'Auto-draft',
    tv: 'TV',
};
